import { CollapsibleSection } from "./collapsible";
import React from "react";
import { ChevronDown, FileText, LifeBuoy, Mail, ShieldCheck } from "lucide-react";
import { privacyPolicyHtml } from "./privacyPolicy";
import { termsOfServiceHtml } from "./termsOfService";

const SUPPORT_EMAIL = "support@phyber.care";

// Legal documents shown as collapsible sections
const legalSections = [
  {
    title: "Terms of Service",
    subtitle: "Effective 15 January 2025",
    icon: FileText,
    html: termsOfServiceHtml,
  },
  {
    title: "Privacy Policy",
    subtitle: "Last updated 21 July 2026",
    icon: ShieldCheck,
    html: privacyPolicyHtml,
  },
];

// fullWidth: fill the parent instead of centring at 900px (used inside the admin Settings layout)
const SupportLegal = ({ fullWidth = false }) => {
  return (
    <div className="w-full bg-white rounded-2xl p-4 md:p-6">
      <div className={`w-full ${fullWidth ? "" : "max-w-[900px] mx-auto"} flex flex-col gap-6`}>
        {/* Header */}
        <div>
          <h1 className="text-xl font-bold text-[#171717] font-poppins mb-0">
            Support & Legal
          </h1>
          <p className="text-xs text-[#64748B] font-poppins mt-0.5 mb-0">
            Need help? Access resources or raise a support request.
          </p>
        </div>

        {/* Raise a Ticket */}
        <div className="rounded-2xl border border-solid border-[#DBEAFE] bg-gradient-to-br from-[#EFF6FF] to-[#F8FAFC] p-[20px] flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="w-12 h-12 shrink-0 rounded-xl bg-white shadow-sm flex items-center justify-center">
            <LifeBuoy className="w-6 h-6 text-[#2563EB]" />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-base font-semibold text-[#171717] font-poppins mb-0.5">
              Raise a Ticket
            </h2>
            <p className="text-[13px] text-[#64748B] font-poppins mb-0">
              Facing an issue or have a question? Mail us at{" "}
              <span className="font-semibold text-[#2563EB]">{SUPPORT_EMAIL}</span>{" "}
              and our team will get back to you.
            </p>
          </div>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="btn-gradient shrink-0 inline-flex items-center justify-center gap-2 h-10 px-[20px] rounded-lg text-sm font-medium font-poppins text-white no-underline"
          >
            <Mail className="w-4 h-4" />
            Email Support
          </a>
        </div>

        {/* Legal */}
        <div className="flex flex-col gap-3">
          <h2 className="text-xs font-semibold uppercase tracking-wider text-[#64748B] font-poppins mb-0">
            Legal
          </h2>
          {legalSections.map(({ title, subtitle, icon: Icon, html }) => (
            <CollapsibleSection
              key={title}
              className="bg-white border border-solid border-[#E2E8F0] rounded-2xl shadow-sm overflow-hidden"
              trigger={(isOpen) => (
                <div className="flex w-full items-center gap-3 py-[14px] px-[16px]">
                  <div className="w-10 h-10 shrink-0 rounded-xl bg-[#EFF6FF] flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#2563EB]" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="block text-sm font-poppins text-[#171717] font-semibold">
                      {title}
                    </span>
                    <span className="block text-xs font-poppins text-[#64748B]">
                      {subtitle}
                    </span>
                  </div>
                  <ChevronDown
                    className={`w-4 h-4 text-[#64748B] transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  />
                </div>
              )}
            >
              <div
                className="h-[420px] overflow-y-auto rounded-xl bg-[#F8FAFC] border border-solid border-[#E2E8F0] p-[20px] font-poppins text-[14px]"
                dangerouslySetInnerHTML={{ __html: html }}
              ></div>
            </CollapsibleSection>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SupportLegal;
